import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Divider, Button, Spin, Modal, Input } from 'antd';
import moment from 'moment';

import Responsive from './Responsive';
import { useLocation, useNavigate } from 'react-router-dom';
import { ButtonText, ModalData, ModalHeading } from '../CommonText';
// import { createAppointmentRequest } from './Actions';
// import { useDispatch } from 'react-redux';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const ScheduleDetails = () => {
    const [states, setState] = useState({
        TotalAmount: 1,
        uhid: '',
        patientIdSchedules: null,
        bankCharge: 0,
        tax: 0,
        quikDrFee: 0,
        visibleCoupon: false,
        scheduleDetails: null,
        visible: false,
        couponValue: ''
    });

    const { state } = useLocation();
    const navigate = useNavigate();
    // const dispatch = useDispatch();

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    
    const ScheduleDetails = [];
    // const paymentInfo = [];
    const requesting = [];
    // const microClinicDetails = [];
    // const orgFees = [];
    // const patientDetails = [];
    // const coupondiscount = [];



    useEffect(() => {
        // Lifecycle equivalent for componentDidMount
        const scheduleData = state.payload.updatedScheduleData.data;
        const item = scheduleData && scheduleData[0];
        let consultationfees;
        let quikdrFees;
        let QuikDrTaxs;
        let totals;
        let BankCharges;
        let FinalAmounts;

        setState(prevState => ({
            ...prevState,
            scheduleDetails: scheduleData
        }));

        consultationfees = Number(item?.orgfee?.amount);

        if (item?.organisation?.quikdrFeeType === 'Fixed') {
            quikdrFees = Number(item?.organisation?.quikdrFeeAmount);
        } else if (item?.organisation?.quikdrFeeType === 'Variable') {
            quikdrFees = Number(
                consultationfees * (item?.organisation?.quikdrFeeAmount / 100)
            );
        }

        QuikDrTaxs = Number(
            quikdrFees * (item?.organisation?.taxPercent / 100)
        );
        totals = Number(consultationfees + quikdrFees + QuikDrTaxs);
        BankCharges =
            (totals * (Number(item?.organisation?.bankChargePercent) / 100)).toFixed(2);
        FinalAmounts = (Number(totals) + Number(BankCharges)).toFixed(2);

        localStorage.setItem('FINAL_AMOUNT', consultationfees);

        // dispatch({ type: REQUEST_PAYMENT, payload: FinalAmounts });
        // dispatch({ type: PARENT_PATIENT_GET_SCHEDULES });

        setState(prevState => ({
            ...prevState,
            quikDrFee: quikdrFees,
            bankCharge: BankCharges,
            tax: QuikDrTaxs.toFixed(2),
            TotalAmount: FinalAmounts,
            visible: false,
        }));
    }, []);

    // const showModal = () => {
    //     setState(prevState => ({
    //         ...prevState,
    //         visible: true,
    //     }));
    // };

    const handleApply = () => {
        setState(prevState => ({
            ...prevState,
            visibleCoupon: false
        }));
        // dispatch({ type: COUPON_PATCH, payload: states.couponValue });
    };

    const inputCoupon = (e) => {
        setState(prevState => ({
            ...prevState,
            couponValue: e.target.value
        }));
    };

    const handleOk = () => {
        // const items = ScheduleDetails.value;
        // dispatch(push('/timeslot'));
        // dispatch({ type: CANCEL_BOOKING, payload: items.id });
        setState(prevState => ({
            ...prevState,
            visible: false,
            loading: false,
        }));
    };

    const handleCancel = () => {
        setState(prevState => ({
            ...prevState,
            visible: false,
        }));
    };

    const cancelVisibleCouple = () => {
        setState(prevState => ({
            ...prevState,
            visibleCoupon: false,
        }));
    };

    // const onPatientChange = (value) => {
    //     localStorage.setItem('REQ_PATIENT_ID_SCHEDULES', value);
    //     setState(prevState => ({
    //         ...prevState,
    //         patientIdSchedules: value
    //     }));
    // };

    const openCheckout = () => {
        const info = state.paymentData ;

        window.open(info.short_url);

        navigate('/appointment');
    };

    // if (patientDetails.value !== null) {
    //     const patientName = patientDetails.value.data.map(item => (
    //         <Option value={item.id}>
    //             {item.firstName} {item.lastName}
    //         </Option>
    //     ));
    // }

    if (ScheduleDetails.value !== null) {
        const { visible, loading } = states;
        const item = states.scheduleDetails && states.scheduleDetails.map((items) => (items))[0];
        const date = moment(item?.date).format('dddd');
        const consultationType = localStorage.getItem('CONSULT_TYPE');
        const type = consultationType === 'walk' ? 'Hospital Visit' : 'Video Consultation';
        // const microClinic = microClinicDetails;
        let venue;
        // const clinicId = localStorage.getItem('MICROCLINIC');

        venue = (
            <Col lg={12} xs={24} md={12}>
                <strong>{langdata.OrganisationC ? langdata.OrganisationC : 'Organisation : '}</strong> {item?.organisation?.name}
            </Col>
        );
        
        const temptime = `${item?.date},${item?.time} GMT+0530 (India Standard Time)`;
        
        const istTime = temptime && new Date(temptime);        
        const utcDate = moment(istTime).toISOString();
        const localDate = new Date(utcDate);
        const timeDisplay = moment(localDate).format('hh:mm A');
        const timeDate = moment(localDate).format('YYYY-MM-DD');
        const finalAmount = item?.orgfee?.amount;

        return (
            <div>
                {requesting.value === true ? (
                    <div style={{ paddingLeft: '50%', paddingTop: '150px' }}>
                        <Spin size="large" />
                    </div>
                ) : (
                    <div>
                        <div style={{ padding: 25, fontFamily: 'Roboto' }}>
                            <Responsive />

                            <Row type="flex" justify="center" align="middle">
                                <Col xs={24} lg={20} xl={18} xxl={18} md={24} sm={24}>
                                    <Card>
                                        <Col>
                                            <strong><ModalHeading text = {langdata.DoctorDetails ? langdata.DoctorDetails : 'Doctor Details'} /></strong>
                                        </Col>
                                        <Divider />
                                        <Row>
                                            <Col lg={12} xs={24} md={12}>
                                                <strong><ModalData color = '#000000' text = {langdata.NameC ? langdata.NameC : 'Name :'} /> </strong>{' '}
                                                {`${item?.doctor?.initials} ${item?.doctor?.firstName} ${item?.doctor?.lastName}`}
                                            </Col>
                                            <Col lg={12} xs={24} md={12}>
                                                <strong><ModalData color = '#000000' text = {langdata.ConsultationTypeC ? langdata.ConsultationTypeC : 'Consultation Type : '} /></strong> {type}
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            <Col lg={12} xs={24} md={12}>
                                                <strong><ModalData color = '#000000' text = {langdata.DepartmentC ? langdata.DepartmentC : 'Department :'} /> </strong> {item?.doctor?.specialization.specialization}
                                            </Col>
                                            <Col lg={12} xs={24} md={12}>
                                                <strong><ModalData color = '#000000' text = {langdata.QualificationC ? langdata.QualificationC : 'Qualification :'} /> </strong> {item?.doctor?.descriptions}
                                            </Col>
                                        </Row>
                                        <br />
                                        <br />                                        
                                        <Col xs={24} lg={14} md={14}>
                                            <strong><ModalHeading text = {langdata.AppointmentDetails ? langdata.AppointmentDetails : 'Appointment Details'} /></strong>
                                        </Col>
                                        <Divider />
                                        <Row>
                                            <Col lg={12} xs={24} md={12}>
                                                <strong><ModalData color = '#000000' text = {langdata.DayC ? langdata.DayC : 'Day : '}/> </strong> {date}
                                            </Col>
                                            <Col lg={12} xs={24} md={12}>
                                                <strong><ModalData color = '#000000' text = {langdata.TimeC ? langdata.TimeC : 'Time :'} /> </strong> {timeDisplay}
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            <Col lg={12} xs={24} md={12}>
                                                <strong><ModalData color = '#000000' text = {langdata.DateC ? langdata.DateC : 'Date : '}/> </strong> {timeDate}
                                            </Col>
                                            {venue}
                                        </Row>
                                        <br />
                                        <br />
                                        <Col xs={24} lg={14} md={14}>
                                            <strong><ModalHeading text = {langdata.FeeDetails ? langdata.FeeDetails : 'Fee Details'} /></strong>
                                        </Col>
                                        <Divider />
                                        <Col lg={4} xs={24} md={4}>
                                            <span><strong><ModalData color = '#000000' text = {langdata.TotalC ? langdata.TotalC : 'Total :'} /> </strong> {`₹ ${finalAmount}`} </span>
                                        </Col>
                                        <Col>
                                            <div style={{ float: 'right', marginTop: '2%' }}>
                                                <Button type="primary" size="large" onClick={openCheckout}>
                                                    <ButtonText text = {langdata.Confirm ? langdata.Confirm : 'Confirm'  }/>
                                                </Button>
                                            </div>
                                            <div>
                                                <Modal
                                                    title={langdata.CancelBooking ? langdata.CancelBooking : 'Cancel Booking'}
                                                    visible={visible}
                                                    onOk={handleOk}
                                                    onCancel={handleCancel}
                                                    footer={[
                                                        <Button key="back" onClick={handleCancel}>{langdata.No ? langdata.No : 'No' }</Button>,
                                                        <Button key="submit" type="primary" loading={loading} onClick={handleOk}>{langdata.Yes ? langdata.Yes : 'Yes' }</Button>,
                                                    ]}
                                                >
                                                    <p>{langdata.Doyouwanttocancelthisbooking ? langdata.Doyouwanttocancelthisbooking : 'Do you want to cancel this booking?' }</p>
                                                    <p>{langdata.Thiswillredirectyoutoselecttimeslot ? langdata.Thiswillredirectyoutoselecttimeslot : 'This will redirect you to select timeslot.' }</p>
                                                </Modal>
                                                <Modal
                                                    title={langdata.ApplyCoupon ? langdata.ApplyCoupon : 'Apply Coupon'}
                                                    visible={states.visibleCoupon}
                                                    onOk={handleApply}
                                                    onCancel={cancelVisibleCouple}
                                                    footer={[
                                                        <Button key="back" onClick={cancelVisibleCouple}>{langdata.No ? langdata.No : 'No' }</Button>,
                                                        <Button key="submit" type="primary" onClick={handleApply}>{langdata.Apply ? langdata.Apply : 'Apply' }</Button>,
                                                    ]}
                                                >
                                                    {langdata.ApplycouponcodeC ? langdata.ApplycouponcodeC : 'Apply coupon code:' }
                                                    <Input placeholder="Enter coupon code" onChange={inputCoupon} />
                                                </Modal>
                                            </div>
                                        </Col>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return null;
};



export default ScheduleDetails;
